var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
var TRACKER_ATTR = 'tid';
// const API_BASE = 'http://localhost:8000/api'
var API_BASE = 'https://greenenergyfundapp.com/api';
var USER_ID_KEY = 'user-id';
var params = new URLSearchParams(window.location.search);
var getUserId = function () {
    return localStorage.getItem(USER_ID_KEY);
};
var setUserId = function (newId) {
    if (newId)
        localStorage.setItem(USER_ID_KEY, newId);
};
var pingTracker = function (trackerId_1, contactId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([trackerId_1, contactId_1], args_1, true), void 0, function (trackerId, contactId, contactType, data) {
        var res;
        if (contactType === void 0) { contactType = 'CONTRACTOR'; }
        if (data === void 0) { data = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('post data start');
                    return [4 /*yield*/, axios.post("".concat(API_BASE, "/tracker/ping/"), {
                            tracker: trackerId,
                            event_source: 'WordPress Button',
                            contact: {
                                uuid: contactId,
                                type: contactType,
                            },
                            data: __assign({ origin: window.location.toString() }, data),
                        })];
                case 1:
                    res = _a.sent();
                    console.log('Ping tracker response:', res);
                    return [2 /*return*/];
            }
        });
    });
};
var setupTrackingButtons = function () {
    var buttons = $("[".concat(TRACKER_ATTR, "]"));
    var userId = getUserId();
    console.log('buttons:', buttons);
    if (userId) {
        buttons.each(function (i, el) {
            $(el).on('click', function (e) { return __awaiter(void 0, void 0, void 0, function () {
                var trackerId, link;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            trackerId = (_a = $(el).attr(TRACKER_ATTR)) !== null && _a !== void 0 ? _a : '';
                            link = (_b = $(el).children().find('a[href]')) === null || _b === void 0 ? void 0 : _b.attr('href');
                            if (!link) return [3 /*break*/, 2];
                            e.preventDefault();
                            return [4 /*yield*/, pingTracker(trackerId, userId)];
                        case 1:
                            _c.sent();
                            window.location.href = link !== null && link !== void 0 ? link : '/';
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, pingTracker(trackerId, userId)];
                        case 3:
                            _c.sent();
                            _c.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        });
    }
};
var setupVideoTracking = function () {
    var userId = getUserId();
    var videoTargets = $("[".concat(TRACKER_ATTR, "]:has( video)"));
    console.log('video targets:', videoTargets);
    videoTargets.each(function (i, el) {
        $(el)
            .find('video')
            .each(function (i, video) {
            $(video).attr('webkit-playsinline', '');
            $(video).attr('playsinline', '');
        });
    });
    if (userId) {
        videoTargets.each(function (i, el) {
            var _a;
            var trackerId = (_a = $(el).attr(TRACKER_ATTR)) !== null && _a !== void 0 ? _a : '';
            $(el)
                .find('video')
                .each(function (i, video) {
                $(video).attr('webkit-playsinline', '');
                $(video).attr('playsinline', '');
                // video.setAttribute('webkit-playsinline', '')
                // video.setAttribute('webkit-playsinline', '')
                $(video).on('play', function (e) {
                    var _a;
                    console.log('Video played:', e.target.currentTime);
                    pingTracker(trackerId, userId, 'CONTRACTOR', {
                        duration: (_a = e.target) === null || _a === void 0 ? void 0 : _a.currentTime,
                        action: 'play',
                    });
                });
                $(video).on('pause', function (e) {
                    var _a;
                    console.log('Video paused:', e);
                    pingTracker(trackerId, userId, 'CONTRACTOR', {
                        duration: (_a = e.target) === null || _a === void 0 ? void 0 : _a.currentTime,
                        action: 'pause',
                    });
                });
            });
        });
    }
};
export var activateTracking = function () {
    var newUserId = params.get('id');
    setUserId(newUserId);
    setupTrackingButtons();
    setupVideoTracking();
};
